import { z } from 'zod';

/**
 * Company, People's address: `?mobile=<address>` is the inbox notice's Add-to-jobs for someone waiting in
 * Paige Mobile (4.6). A value that is not an address (a mangled or hand-typed link) opens People as it is,
 * never the error page.
 */
export const peopleSearch = z.object({
  mobile: z.string().email().max(254).optional().catch(undefined),
});
